export default __webpack_public_path__ + "static/media/user-solid.93b18c33.svg";